<template>
  <section v-if="settings" class="Publisher__writer">
    <div class="Publisher__box">
      <div class="publiasher__desc">
        <p>ناشران</p>
        <router-link to="/publishers">مشاهده همه</router-link>
      </div>
      <div>
        <ul class="somePW">
          <template v-for="(publisher, index) in publishers">
              <li>
            <router-link
              v-if="index < min"
              :to="`/book-list?publisher_id[0]=${publisher.id}`"
              :key="publisher.id"
            >
                <img :src="publisher.image" :alt="publisher.name" />
                <h6>{{ publisher.name }}</h6>
            </router-link>
              </li>
          </template>
        </ul>
      </div>
    </div>

    <div class="writer__box">
      <div class="writer__desc">
        <p>نویسندگان</p>
        <router-link to="/authors">مشاهده همه</router-link>
      </div>
      <div>
        <ul class="somePW">
          <template v-for="(author, index) in authors">
              <li>
            <router-link
              :to="`/book-list?author_id[0]=${author.id}`"
              v-if="index < min"
              :key="index"
            >
                <img :src="author.image" :alt="author.name" />
                <h6>{{ author.name }}</h6>
            </router-link>
              </li>
          </template>
        </ul>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  props: {
    publishers: Array,
    authors: Array,
  },

  computed: {
    min() {
      if (window.innerWidth < 768) {
        return 9;
      } else {
        return 10;
      }
    },
    settings() {
      return this.$store.getters.getSettings;
    },
  },
};
</script>
<style scoped>
ul.somePW a {
  color: black;
}
ul.somePW {
  justify-content: space-between;
}
.somePW li img {
  width: 100% !important;
  height: 100px !important;
  object-fit: fill;
}
.somePW li h6 {
  width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 20px;
  white-space: nowrap;
  text-align: center;
}
@media (min-width:1900px){
.somePW li h6 {
  width:140px
}
}
@media (max-width: 768px) {
  ul.somePW {
    grid-template-columns: 1fr 1fr 1fr !important;
  }
}
@media (max-width:1300px) and (min-width:1100px){
    ul.somePW {
      grid-template-columns: repeat(4,1fr) !important;
    }
}
</style>
